import { useStoreState } from 'easy-peasy';
import { useQuery } from 'react-query';

import { QueryKey } from '@ge/models/constants';
import { Config } from '@ge/shared/data-hooks';
import { fetchAllContracts } from '@ge/shared/services/kpi';

export const useCrContractsData = () => {
  const { sitesForView } = useStoreState((state) => state.sites);
  const siteIds = sitesForView.map((site) => site.id);

  const params = {
    siteIds,
  };

  const { data: _data, isLoading } = useQuery(
    [QueryKey.CR_CONTRACTS, siteIds],
    () => fetchAllContracts(params),
    {
      ...Config.EXECUTE_ONCE,
    },
  );

  return {
    isLoading: isLoading,
    data: _data?.data || [],
  };
};
